<div class="hotel-search" *ngIf="isMobile; else desktop">
  <div class="hotel-search-content" [class.mobile-results]="isResults" [class.detail-mobile]="isHotelDetail">
    <app-search-input-destination
      *ngIf="!isHotelDetail"
      [searchType]="searchType"
      [isMobile]="isMobile"
      [autofocus]="true"
      [icon]="icons.Location"
      [placeType]="arrival"
      [place]="destinationHotelPlace$ | async"
      [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.TO_MOBILE' | transloco"
      [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION_MOBILE' | transloco"
      [autoCompletePlaces]="autocompleteDestinationPlaces$ | async"
      [showError]="isPlaceSelectedEmpty"
      (selectDestination)="selectPlace($event)"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
      (inputChanged)="placeInputChanged($event)"
      (showSearchInput)="showDestination.emit($event)"
      (removeAutoCompletePlaces)="clearAutocompletePlaces()"
      (locationNotFoundEvent)="locationNotFoundEvent($event)"
      (popularAmplitudeEvent)="popularSelectedEvent($event)"
      (selectSimpleDestination)="selectPlace($event)">
    </app-search-input-destination>
    <div class="hotel-calendar-inputs">
      <div class="hotel-calendar-input departure">
        <app-search-bar-input
          [isMobile]="isMobile"
          [searchType]="searchType"
          [label]="'SEARCH_MODULE.LOCATION_SEARCH.DEPART' | transloco"
          [placeholder]="'DATE' | transloco"
          [value]="departureDate | hotelSearchDate"
          [icon]="icons.Calendar"
          [swapPlaceholder]="true"
          [readOnly]="true"
          [showError]="isDepartureDateEmpty"
          (isFocus)="showMobileCalendar(calendarField.departure)">
        </app-search-bar-input>
      </div>
      <div class="hotel-calendar-input arrival">
        <app-search-bar-input
          [isMobile]="isMobile"
          [searchType]="searchType"
          [label]="'SEARCH_MODULE.LOCATION_SEARCH.RETURN' | transloco"
          [placeholder]="'DATE' | transloco"
          [value]="arrivalDate | hotelSearchDate"
          [icon]="icons.Calendar"
          [swapPlaceholder]="true"
          [readOnly]="true"
          [showError]="isArrivalDateEmpty"
          (isFocus)="showMobileCalendar(calendarField.arrival)">
        </app-search-bar-input>
      </div>
    </div>
    <div class="hotel-rooms">
      <app-search-bar-room
        [icon]="icons.ChevronFilledDown"
        [id]="'search-bar-hotel-room'"
        [label]="'HOTELS_MODULE.HOME.ROOMS_LABEL' | transloco"
        [placeholder]="'HOTELS_MODULE.HOME.ROOMS_PLACEHOLDER' | transloco"
        [control]="roomControl"
        [isMobile]="isMobile"
        [intialRooms]="rooms"
        [isHotelDetail]="isHotelDetail"
        (fetchMessageAction)="fetchMessageAction()"
        (setGuestsPerRoom)="setGuestsPerRoom($event)"
        (addNewRoom)="addRoom($event)"
        (removeRoom)="removeRoom($event)"
        (isShowed)="showSearchBarRoom()"
        (emitRoomsSelection)="roomsSelection($event)">
      </app-search-bar-room>
    </div>
  </div>
  <app-fixed-surface
    [boxShadow]="true">
    <app-ds-button
      [isLoading]="loadSearchData"
      [labels]="{ ButtonLabel: 'BUTTONS.SEARCH' | transloco }"
      (clickEvent)="navigateToSearch()">
    </app-ds-button>
  </app-fixed-surface>
</div>

<ng-template #desktop>
  <div class="hotel-search desktop" [class.results]="isResults || isHotelDetail" [class.hotel-search-home]="hotelSearchHome">
    <div class="hotel-search-content">
      <div class="hotel-calendar-inputs" [class.detail-desktop-search]="isHotelDetail">
        <div class="hotel-place-content" *ngIf="!isHotelDetail">
          <app-search-input-destination
            [searchType]="searchType"
            [showError]="isPlaceSelectedEmpty"
            [isHome]="hotelSearchHome"
            [isMobile]="isMobile"
            [eventPath]="eventPath | async"
            [autofocus]=true
            [icon]="icons.Location"
            [placeType]="arrival"
            [place]="destinationHotelPlace$ | async"
            [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.TO' | transloco"
            [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION' | transloco"
            [autoCompletePlaces]="autocompleteDestinationPlaces$ | async"
            (selectDestination)="selectPlace($event)"
            [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
            (inputChanged)="placeInputChanged($event)"
            (removeAutoCompletePlaces)="clearAutocompletePlaces()"
            (locationNotFoundEvent)="locationNotFoundEvent($event)"
            (popularAmplitudeEvent)="popularSelectedEvent($event)"
            (selectSimpleDestination)="selectPlace($event)">
          </app-search-input-destination>
        </div>
        <div class="hotel-calendar-input departure">
          <app-search-bar-input
                  [isMobile]="isMobile"
                  [id]="'calendar-departure'"
                  [showError]="isDepartureDateEmpty"
                  [searchType]="searchType"
                  [label]="'SEARCH_MODULE.LOCATION_SEARCH.DEPART' | transloco"
                  [placeholder]="'DATE' | transloco"
                  [value]="departureDate | hotelSearchDate"
                  [icon]="icons.Calendar"
                  [swapPlaceholder]="true"
                  [readOnly]="true"
                  (isFocus)="setCalendarField('left')">
          </app-search-bar-input>
        </div>
        <div class="hotel-calendar-input arrival">
          <app-search-bar-input
                  [isMobile]="isMobile"
                  [id]="'calendar-arrival'"
                  [showError]="isArrivalDateEmpty"
                  [searchType]="searchType"
                  [label]="'SEARCH_MODULE.LOCATION_SEARCH.RETURN' | transloco"
                  [placeholder]="'DATE' | transloco"
                  [value]="arrivalDate | hotelSearchDate"
                  [icon]="icons.Calendar"
                  [swapPlaceholder]="true"
                  [readOnly]="true"
                  (isFocus)="setCalendarField('right')">
          </app-search-bar-input>
        </div>
        <div class="hotel-rooms">
          <app-search-bar-room
            [icon]="icons.ChevronFilledDown"
            [searchType]="searchType"
            [isHome]="hotelSearchHome"
            [eventPath]="eventPath | async"
            [id]="'search-bar-hotel-room'"
            [label]="'HOTELS_MODULE.HOME.ROOMS_LABEL' | transloco"
            [placeholder]="'HOTELS_MODULE.HOME.ROOMS_PLACEHOLDER' | transloco"
            [control]="roomControl"
            [isMobile]="isMobile"
            [intialRooms]="rooms"
            (fetchMessageAction)="fetchMessageAction()"
            (setGuestsPerRoom)="setGuestsPerRoom($event)"
            (emitRoomsSelection)="roomsSelection($event)"
            (addNewRoom)="addRoom($event)"
            (removeRoom)="removeRoom($event)">
          </app-search-bar-room>
        </div>
        <app-search-bar-calendar
          [isHotelDetail]="isHotelDetail"
          [arrivalDate]="arrivalDate"
          [departurePlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.DEPART' | transloco"
          [returnPlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.RETURN' | transloco"
          [departureDate]="departureDate"
          [show]="showCalendarInput"
          [fieldActivated]="dateCalendarField"
          [searchType]="searchType"
          (emitApplySelection)="applyCalendar($event)">
        </app-search-bar-calendar>
      </div>
    </div>
    <div class="search-button">
      <app-ds-button
        [showIcon]="true"
        [icon]="icons.Search"
        [size]="buttonSize"
        (clickEvent)="navigateToSearch()">
      </app-ds-button>
    </div>
  </div>
</ng-template>
